import styled from 'styled-components';
import withColor from 'util/hoc/with-color';
import Collapsable from 'library/components/collapsable';
import Caret from 'library/icons/caret.svg';

const CollegeCollapsable = styled(Collapsable)`
  transition: height .2s ease-in-out;
  will-change: height;
  overflow: hidden;
  background-color: #FBFBFB;
  box-shadow: inset 0 2px 0 0 #E8E8E6, inset 7px 0 0 0 #D7D7D7;
  div.collapsableBody {
    border-radius: 4px;
    padding: 1em;
    height: auto;
    width: 100%;
    min-width: 300px;
    display: flex;
    flex-wrap: wrap;
  }
`;

const ItemWithDate = withColor(styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-bottom: 1em;
  h4 {
    margin-top: 0em;
    margin-bottom: 0em;
  }
  span {
    color: ${props => props.colors.grey2};
  }
`);

const ListItem = withColor(styled.li`
  margin-left: 1em;
  width: 100%;
`);

const CollapsableCaret = styled(Caret)`
  ${props => props.collapsed ? null : 'transform: rotate(180deg);'}
`;

const PanelBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const CollapsableHeader = withColor(styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  padding: 0 1em;
  height: 50px;
  width: 100%;
  min-width: 300px;
  border-radius: 4px 4px 0 0;
  background-color: #FFFFFF;
  box-shadow: inset 7px 0 0 0 #19637D, inset 0 2px 0 0 #D7D7D7, inset 0 -2px 0 0 #D7D7D7, inset -2px -1px 0 0 #D7D7D7;
  h3 {
    color: ${props => props.colors.grey1};
  }
`);

export {
  CollegeCollapsable,
  ItemWithDate,
  ListItem,
  CollapsableCaret,
  PanelBody,
  CollapsableHeader
};